export const TICKET_STATUS_NOMINATED = 'NOMINATED';
export const TICKET_STATUS_AWAITING_NOMINATION = 'AWAITING_NOMINATION';
export const TICKET_STATUS_AWAITING_SPECIALIST = 'AWAITING_SPECIALIST';
export const TICKET_STATUS_ESCALATED = 'ESCALATED';
export const TICKET_STATUS_ESC_FOR_REVIEW = 'ESC_FOR_REVIEW';
export const TICKET_STATUS_ASSIGNED = 'ASSIGNED';
export const TICKET_STATUS_CLOSED = 'CLOSED';
export const TICKET_STATUS_UNASSIGNED_CLOSED = 'UNASSIGNED_CLOSED';
export const TICKET_STATUS_HIDDEN = 'HIDDEN';
export const TICKET_STATUS_NEW = 'NEW';
export const TICKET_STATUS_PAUSED = 'PAUSED';
export const TICKET_STATUS_TAKEN_BY_SMB = 'TAKEN_BY_SMB';
export const TICKET_STATUS_SENTBACK = 'SENTBACK';
export const TICKET_STATUS_TIMEOUT_CONVERSATION_CLOSED = 'TIMEOUT_CLOSED';
export const TICKET_STATUS_NOMINATED_FROM_ESCALATED = 'NOMINATED_FROM_ESCALATED';
export const TICKET_STATUS_SELF_HELP = 'SELF_HELP';
export const TICKET_STATUS_DELETED = 'DELETED';

export const FORWARD_TO_EXPERTS_TICKET_STATUSES = [TICKET_STATUS_AWAITING_SPECIALIST];
export const NOMINATED_TICKET_STATUSES = [TICKET_STATUS_NOMINATED, TICKET_STATUS_NOMINATED_FROM_ESCALATED];
export const ticketStatesClosed = [TICKET_STATUS_CLOSED, TICKET_STATUS_UNASSIGNED_CLOSED];

export const NOMINATED_FOR_REVIEW = 'NOMINATED_FOR_REVIEW';

// TICKET_STATUS_FILTER is used to populate the Specialist Portal "Status" filter.
export const TICKET_STATUS_FILTER = Object.freeze({
  all: 'ALL',
  forwardToExperts: 'FORWARD_TO_EXPERTS',
  awaitingNomination: TICKET_STATUS_AWAITING_NOMINATION,
  paused: TICKET_STATUS_PAUSED,
  assigned: TICKET_STATUS_ASSIGNED,
  closed: TICKET_STATUS_CLOSED,
  nominated: TICKET_STATUS_NOMINATED,
  takenBySMB: TICKET_STATUS_TAKEN_BY_SMB,
  unassignedClosed: TICKET_STATUS_UNASSIGNED_CLOSED,
  new: TICKET_STATUS_NEW,
  escalated: TICKET_STATUS_ESCALATED,
  sentback: TICKET_STATUS_SENTBACK,
});
